export default __webpack_public_path__ + "static/media/closet5-after1-2048w.3da8561c.avif";